import { ElLoading } from 'element-plus';
import request, { downFile } from '@/utils/request';
/** 设备管理 */
/** 分页查询 */
export function equipmentPage (query) {
  return request({
    url: `/model/equipment/page`,
    method: 'post',
    data: query
  });
}

/** 保存 */
export function equipmentSave (data) {
  return request({
    url: `/model/equipment/save`,
    method: 'post',
    data: data
  });
}

/** 删除 */
export function equipmentDelete (id) {
  return request({
    url: `/model/equipment/delete/${id}`,
    method: 'get'
  });
}

/** 获取设备数据 */
export function getEquipmentData (id) {
  return request({
    url: `/model/equipment/getEquipmentData/${id}`,
    method: 'get'
  });
}
/** 获取设备连接 */
export function getEquipmentConnect (id) {
  return request({
    url: `/model/equipment/getEquipmentConnect/${id}`,
    method: 'get'
  });
}
/** 获取设备服务数据（可下发命令） */
export function getEquipmentConnectData (id) {
  return request({
    url: `/model/equipment/getEquipmentConnectData/${id}`,
    method: 'get'
  });
}

/** 获取区域设备 */
export function getAreaEquipment (data) {
  return request({
    url: `/model/equipment/getAreaEquipment`,
    params: data,
    method: 'get'
  });
}


/**设备数据导出excel */
export function equipmentExport (id) {
  const loading = ElLoading.service({
    lock: true,
    text: '正在导出文件...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  return request({
    url: `/model/equipment/export/${id}`,
    method: 'get',
    responseType: 'blob'
  }).then((res) => {
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' });

    // eslint-disable-next-line no-undef
    downFile(blob, `导出设备数据.xlsx`);
    loading.close();
  });
}
